module.exports = __webpack_public_path__ + "img/document-black.b8c54e59.svg";